import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import { ProductVersionRestoredInfo, ProductVersions } from '@/api/typings/product';
import { getProductVersions, createProductFromVersion } from '@/api/product';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreTemplateVersion',
  props: {
    templateId: null,
    templateName: null
  },
  emits: ["go-back", "template-version-restored"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'go-back'): void;
    (event: 'template-version-restored', template: ProductVersionRestoredInfo): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    templateId: string;
    templateName: string;
};



const version = ref('');
const saving = ref(false);
const loadingVersions = ref(false);
const errorMessage = ref('');
const newTemplateId = ref('');
const newTemplateName = ref('');
const versions = ref<ProductVersions[]>([]);



const getTemplateVersions = async () => {
    try {
        loadingVersions.value = true;
        versions.value = await getProductVersions(props.templateId);
    } finally {
        loadingVersions.value = false;
    }
};

const goBack = () => {
    emit('go-back');
};

const restoreTemplateVersion = async () => {
    try {
        saving.value = true;
        const versionDate = versions.value.find((v) => v.VersionId == version.value)?.LastModified;
        if (versionDate) {
            newTemplateName.value = `${props.templateName} - Restored version: ${versionDate
                .toLocaleString('en-US', { timeZone: 'UTC' })
                .replace('T', ' ')}`;
            newTemplateId.value = await createProductFromVersion(
                props.templateId,
                version.value,
                newTemplateName.value
            );
            emit('template-version-restored', { templateId: newTemplateId.value, templateName: props.templateName });
        }
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.request?.status !== 404) {
            window.rumReportError(axiosError);
            errorMessage.value = `Error restoring product ${props.templateName} version ${
                axiosError.response?.data?.Message ?? ''
            }`;
        }
    } finally {
        saving.value = false;
    }
};

onMounted(async () => {
    await getTemplateVersions();
});

return { __sfc: true,props, version, saving, loadingVersions, errorMessage, newTemplateId, newTemplateName, versions, emit, getTemplateVersions, goBack, restoreTemplateVersion, LoaderBtn }
}

})